import { Lang } from "../../types";
import { generateNewsUrl, generatePlayerUrl, generateTeamUrl, getHost, getLangPath, } from "../index";
export var LinkTypes;
(function (LinkTypes) {
    LinkTypes["News"] = "news";
    LinkTypes["Player"] = "player";
    LinkTypes["Team"] = "team";
})(LinkTypes || (LinkTypes = {}));
const linkTypeGeneratorMap = {
    [LinkTypes.News]: generateNewsUrl,
    [LinkTypes.Player]: generatePlayerUrl,
    [LinkTypes.Team]: generateTeamUrl,
};
export const generateUrl = ({ basePath, clubPath, contextUrlPrefix, host: hostOption, isApp = false, lang = Lang.EN, linkType = LinkTypes.News, queryString, rootRelative = false, slug, }) => {
    const host = rootRelative ? null : getHost({ host: hostOption, isApp });
    const langPath = getLangPath(lang);
    const urlParts = {
        basePath,
        clubPath,
        contextUrlPrefix,
        host,
        isApp,
        langPath,
        queryString,
        slug,
    };
    return linkTypeGeneratorMap[linkType](urlParts);
};
